import { ProductDisabledType } from '@/features/YTLive/LiveProducts/getProductDisabledType';

const ytLive = {
  'Learn more': '詳細を見る',
  'Field youtubeId': 'YouTube チャンネル ID',
  'Field youtubeUrl': 'YouTube チャンネル URL',
  'Field brandHomeUrl': 'ストア URL',
  'Field date': '配信予定日時',
  'Field date - description':
    'ご注意ください。「配信を開始」をクリックすると、商品が Google Merchant Center および YouTube 管理画面に反映されます。上記の設定完了後は、本番配信の 3 日前までに、対象の YouTube チャンネルでテスト配信を実施し、正常に配信できることを確認することをおすすめします。\n※ YouTube および Google Merchant Center の制限により、配信予定日時は現在時刻から 24 時間以降のみ設定できます。',
  'Live Products': 'ライブ配信商品',
  'Live Products - counter': '({{count}}/{{max}})',
  'Live Products - description':
    '配信予定日時を設定してください。設定した日時になると、非表示の商品がストアの公開ページおよび YouTube の公開画面と管理画面に表示されます。\nまた、Google Merchant Center および YouTube の制限により、配信予定日時を設定した後は、配信開始 24 時間前以降の日時変更はできません。',
  'Live Products - min error':
    'ライブ配信商品は必須です。商品を選択してください。',
  'Live Products - max error':
    '1 つのライブ配信には最大 {{count}} 件の商品まで追加できます。商品の数を減らしてください。',
  'Live Products - nav content': 'ライブ配信商品を選択または作成',
  'Add Products': 'ライブ配信商品を選択',
  'Live Products columns - Product': '商品',
  'Live Products columns - Price': '価格',
  'Live Products columns - Inventory': '販売可能数',
  'Live Products columns - Status': 'ステータス',
  'Live Products status - reminder on': '在庫切れアラート：有効',
  'Live Products status - reminder off': '在庫切れアラート：無効',
  'Live Products status - hidden': '非表示商品',
  'Live Products status - schedulePublishAt': '{{date}} に公開',
  'Live Products status - availableStartTime start': '販売開始：{{date}}',
  'Live Products status - availableStartTime period': '販売期間：{{date}}',
  'Live Products status - availableStartTime end': '販売終了：{{date}}',
  [`Live Prdoucts disabled_${ProductDisabledType.unpublished}`]: '販売終了',
  [`Live Prdoucts disabled_${ProductDisabledType.emptyPrice}`]:
    '価格未設定の商品は追加できません',
  [`Live Prdoucts disabled_${ProductDisabledType.hiddenPrice}`]:
    '価格が非表示の商品は追加できません',
  'LiveProductsPicker - SearchBar placeholder': '商品名または SPU で検索',
  'LiveProductsPicker - No result': '商品が見つかりません',
  'LiveProductsPicker - No result description':
    'キーワードまたはフィルター条件を変更してお試しください',
  'LiveProductsPicker - View selected products':
    '選択済み商品を表示 ({{count}}/{{max}})',
  'LiveProductsPicker - View all products': 'すべての商品を表示',
  'Youtube Admin Preparation': 'YouTube 管理画面の事前準備',
  'Youtube Admin Preparation - description':
    'YouTube の仕様により、現在は SHOPLINE 管理画面から直接ライブ配信を開始することはできません。今後さらに多くのライブ配信機能に対応予定です。ライブ配信を終了する場合は、YouTube 管理画面で操作してください。\nライブ配信で商品を販売する前に、以下の手順をご確認ください。',
  'Youtube Admin Preparation - nav content':
    'YouTube チャンネル側で事前設定を行う',
  'Youtube Admin Preparation StepOne':
    'YouTube Studio でチャンネルに表示する商品を設定する',
  'Youtube Admin Preparation StepOne - description':
    'Google Merchant Center Content API の設定が完了すると、商品は Google Merchant Center および YouTube ショッピングに自動的に同期されます。YouTube 管理画面の設定ページで、ライブ配信中に表示する商品を選択してください。',
  'Youtube Admin Preparation StepTwo': 'ライブ配信で表示する商品をタグ付けする',
  'Youtube Admin Preparation StepTwo - description':
    'ライブ配信中に商品をタグ付けして固定表示することで、視聴者は動画を視聴しながら商品を購入できます。',
  'Youtube Admin Preparation StepThree':
    '配信予定日時にライブ配信を開始し、商品を固定表示する',
  'Youtube Admin Preparation StepThree - description':
    'ライブ配信中は、商品の固定表示機能を利用することで、紹介中の商品をより目立たせることができます。',
  'Finish Setting': 'まもなく完了',
  'Finish Setting - description':
    '以上の設定が完了したら、ライブ配信を開始できます。',
  'Start Streaming': 'YouTube でライブ配信を開始',
  'exceeded the LIVE Broadcast time':
    'このライブ配信は有効期限が切れています（配信予定日時を過ぎています）。今回の編集内容は保存されません。ライブ配信を開始する場合は、新しいライブ配信を作成してください。',
  'Youtube Tnc':
    '本機能を利用するにあたり、関連事項を十分に理解したうえで設定を行ってください。<YoutubePrivacyLink></YoutubePrivacyLink>および以下の関連事項をご確認ください。',
  'Youtube Privacy': 'YouTube プライバシーポリシー',
  'Youtube Tnc Detail':
    'また、YouTube ショッピングを連携することで、オンラインストアにおける YouTube 経由の注文データを YouTube に提供することに同意したものとみなされます。',
  'Setup Guide YouTube Shopping Setup': 'YouTube ショッピングライブ配信設定',
  'Field Channel': 'チャンネル',
  'Setup Guide Choose Channel Title': 'YouTube チャンネルを選択',
  'Setup Guide Choose Channel Description':
    'ご注意：ストアに非表示の商品が含まれている場合、それらの商品は連携済みのすべての YouTube チャンネルの管理画面に表示されます。',
  'Setup Guide Choose Channel Dropdown Placeholder': '選択してください',
  'Setup Guide No Available Channels':
    'ストアと連携している YouTube チャンネルはありません',
  'Setup Now': '有効化へ',
  'Schedule Live Stream Title': '配信予定日時',
  'Schedule Live Stream Description':
    '配信予定日時を選択してください。設定した配信予定日時になると、非表示の商品がストアの公開ページおよび YouTube の公開画面と管理画面に表示されます。\n\n※ Google Merchant Center および YouTube の商品登録制限により、現在時刻から 24 時間以降の日時のみ選択できます。また、配信開始 24 時間前以降は日時を変更できません。',
  'Live Stream Products Title': 'ライブ配信商品',
  'Live Stream Products Description':
    'ライブ配信で紹介する商品を選択してください。選択した商品は、「保存」をクリックした後に Google Merchant Center および YouTube 管理画面に反映されます。',
  'YouTube Preparation Title': 'YouTube 管理画面の事前準備',
  'YouTube Preparation Description':
    'YouTube の仕様により、現在は SHOPLINE 管理画面から直接ライブ配信を開始することはできません。配信の終了も YouTube 側で行ってください。今後さらに多くのライブ配信機能に対応予定です。\nライブ配信で商品を販売する前に、以下の手順をご確認ください。',
  'Account Linking YouTube Preparation StepOne':
    '1. YouTube Studio でチャンネルに表示する商品を設定する',
  'Account Linking YouTube Preparation StepOne - description':
    'Google Merchant Center Content API の設定が完了すると、商品は Google Merchant Center および YouTube 管理画面へ自動的に同期されます。YouTube 管理画面で、チャンネルに表示する商品を選択できます。',
  'Account Linking YouTube Preparation StepTwo':
    '2. ライブ配信で紹介する商品をタグ付けする',
  'Account Linking YouTube Preparation StepTwo - description':
    '商品をタグ付けすることで、ライブ配信中に商品を表示できます。視聴者は配信を視聴しながら商品を購入できます。',
  'Account Linking YouTube Preparation StepThree':
    '3. 配信予定日時にライブ配信を開始し、商品を固定表示する',
  'Account Linking YouTube Preparation StepThree - description':
    'ライブ配信中は、商品の固定表示機能を利用することで、紹介中の商品をより目立たせることができます。',
  'Finish YouTube Setting': 'まもなく完了',
};

export default ytLive;
